import React, { useState, useEffect, useRef } from "react";
import {
    ProTableOt, StatsCard, Row, Col, LucideIcon,
    Form, useCRUDController,
    useProTableOt,
    setParamsFilter,
    Accordion, AccordionItem, AccordionTrigger, AccordionContent,
    Typography, generateShadesFromHex

} from './ot';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "./card";
import styled from "styled-components";

const PageTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: bold;
  color: ${({ color }) => color || "#3730a3"};
`;
const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  border-radius: 0.5rem;
  background: linear-gradient(
  to right,
  ${({ fromColor }) => fromColor || "#eef2ff"},
  ${({ toColor }) => toColor || "#f5f3ff"}
);
`;
const BaseStatsCardHeader = (
    {
        pageTitle = "空間預約及付款",
        primaryColor = '#6366f1',
        secondColor = '#a855f7',
        stats = [{
            value: 3,
            label: "預約數量統計",
            color: "#6366f1",
            backgroundColor: "bg-white",
            icon: < LucideIcon name={"FileText"} />,
            iconPosition: "right",
            animationDuration: 2000,
            animationDelay: 0,

        },
        {
            value: 1,
            label: "報到完成率",
            color: "#3b82f6",
            backgroundColor: "bg-white",
            icon: <LucideIcon name="PlusCircle" />,
            iconPosition: "right",
            animationDuration: 1800,
            animationDelay: 200,

        },
        {
            value: 1,
            label: "平均使用時長",
            color: "#3b82f6",
            backgroundColor: "bg-white",
            icon: < LucideIcon name="PlusCircle" />,
            iconPosition: "right",
            animationDuration: 1800,
            animationDelay: 200,
        },
        {
            value: 1,
            label: "使用高峰時段",
            color: "#3b82f6",
            backgroundColor: "bg-white",
            icon: < LucideIcon name="PlusCircle" />,
            iconPosition: "right",
            animationDuration: 1800,
            animationDelay: 200,
        },
        ]
    }
) => {


    return (<Row>
        <Col span={24}>
            <HeaderContainer fromColor={generateShadesFromHex(primaryColor)?.['50']} toColor={generateShadesFromHex(secondColor)?.['50']}>
                <PageTitle color={generateShadesFromHex(primaryColor)?.['800']}>
                    {pageTitle}
                </PageTitle>

            </HeaderContainer>
            <StatsCard
                layout="horizontal"
                stats={stats}
                enableAnimation={false}
                isLoading={false}
                loadingDuration={1500}
                size={'md'}
                contentAlign={'left'}
                backgroundColor={"bg-white"}
                connection={'separated'}
                columnsPerRow={4}
            />
        </Col>
    </Row>)
}
export default BaseStatsCardHeader;